module.exports = __webpack_public_path__ + "img/36_70.3f739f9f.png";